var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart',_vm._b({attrs:{"params":_vm.params,"value-func":_vm.executeChartDataFunc,"currency-code":_vm.currencyCode}},'chart',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }